import { Link } from "@caprikorn/dynamo-ui";
import { getFullAddress, getFullName } from "@caprikorn/dynamo-utils";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { Link as RouterLink, generatePath } from "react-router-dom";

import { ROUTES } from "@router/router.constants";
import type { Contract } from "@services/apiEcms/apiEcms.types";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

const columnHelper = createColumnHelper<Contract>();

export const usePerimeterConctractsTableColumns = () => {
  const { t } = useCustomTranslation("main");

  const columns = useMemo(
    () => [
      columnHelper.accessor("contractInformation.contractName", {
        header: t("perimeter.contracts.columns.contractName"),
        meta: { isHighlighted: true },
        cell: ({ getValue, row }) => (
          <Link
            as={RouterLink}
            hasNoDecoration
            to={generatePath(ROUTES.PERIMETER_SITES_BY_CONTRACT, {
              customerId: row.original.contractInformation.customerId,
              contractId: row.original.contractInformation.contractId,
            })}
          >
            {getValue()}
          </Link>
        ),
        enableSorting: false,
      }),
      columnHelper.accessor("contractInformation.contractId", {
        header: t("perimeter.contracts.columns.contractId"),
        enableSorting: false,
      }),
      columnHelper.accessor("billingContact", {
        header: t("perimeter.contracts.columns.contactName"),
        enableSorting: false,
        cell: ({ getValue }) => getFullName(getValue()),
      }),
      columnHelper.accessor("billingAddress", {
        header: t("perimeter.contracts.columns.invoiceAddress"),
        enableSorting: false,
        cell: ({ getValue }) => getFullAddress(getValue()),
      }),
    ],
    [t],
  );

  return columns;
};
